//-- keys can be found in src/pages/june-5/SetLocationComponents.js
//-- must match these
export const prettifyName = (key) => {
	switch(key) {
		case "SF":
			return "SF";
		case "SJ":
			return "San Jose";
		case "SantaClaraCounty":
			return "Santa Clara County";
		case "CAOnly":
			return "California";
		default:
			return "SF";
	}
}

//TODO regional measure 3
const SFZips = [94016,94102,94103,94104,94105,94107,94108,94109,94110,94111,94112,94114,94115,94116,94117,94118,94119,94120,94121,94122,94123,94124,94125,94126,94127,94129,94130,94131,94132,94133,94134,94137,94139,94140,94141,94142,94143,94144,94145,94146,94147,94151,94153,94154,94156,94158,94159,94160,94161,94162,94163,94164,94171,94172,94177,94188];
const SJZips = [94088,94089,94538,94560,95002,95008,95013,95035,95037,95050,95054,95101,95103,95106,95108,95109,95110,95111,95112,95113,95115,95116,95117,95118,95119,95120,95121,95122,95123,95124,95125,95126,95127,95128,95129,95130,95131,95132,95133,95134,95135,95136,95138,95139,95141,95148,95150,95151,95152,95153,95154,95155,95156,95157,95158,95160,95161,95164,95170,95172,95173,95190,95191,95192,95193,95194,95196];
// this was calculated as a complement of the set of Santa Clara zips and SJ city zips
const SantaClaraButNotSJZips = [94022,94023,94024,94035,94039,94040,94041,94042,94043,94085,94086,94087,94301,94302,94303,94304,94305,94306,94309,95009,95011,95014,95015,95020,95021,95026,95030,95031,95032,95036,95038,95042,95044,95046,95051,95052,95053,95055,95056,95070,95071,95140,95159];

export const getLocationFromZip = (zipStr) => {
	const zip = parseInt(zipStr, 10);
	if (isNaN(zip)) return "SF";
	if (zip > 90000) { //-- good enough, prob in CA
		if ( SFZips.includes(zip) ) {
			return "SF";
		} else if (SJZips.includes(zip)) {
			return "SJ";
		} else if ( SantaClaraButNotSJZips.includes(zip) ) {
			return "SantaClaraCounty";
		} else {
			return "CAOnly"
		}
	} else {	
		 return "OutsideCA"
	}
}



// WEBPACK FOOTER //
// ./src/pages/june-5/util.js